//import { id } from 'date-fns/locale';
import { makeAutoObservable, runInAction, action } from 'mobx';
//import { GiConsoleController } from 'react-icons/gi';
//import { toast } from 'react-toastify';
import agent from '../api/agent';
import { createCATCursos, createCATCursosFormValues, getCATCursos, lstCourses, Pagination } from '../models/CATCursos';
import { CATEdiciones, CATEdicionesFormValues } from '../models/CATEdiciones';
import { getCATNotas } from '../models/CATNotas';
import { getCATCursoDetail } from '../models/DetailCATCurso';
//import { store } from './store';

export default class CATCursosStore {
    CATCursosRegistry = new Map<any, createCATCursos>();
    getCATCursosRegistry = new Map<any, getCATCursos>();
    getCATCursosNew = new Map<any, getCATCursos>();
    getCATCursosRegistryAll = new Map<any, getCATCursos>();
    getCATNotasRegistry = new Map<any, getCATNotas>();
    getCATCursoRegistryDetail = new Map<any, getCATCursoDetail>();
    

    selectedCATCursos: createCATCursos | undefined = undefined;
    selectedCATEdiciones: CATEdiciones | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    codigoCursoRespuesta: string = "";
    edicion: number = 0;
    totalPages: number = 1;
    currentPage = 1;

    @action setPage(page: number) {
    this.currentPage = page;}

    constructor() {
        makeAutoObservable(this)
    }

    setEdicion = (data: any) => {
        this.edicion = data;
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    createCATCourses = async (createCATCursos: createCATCursosFormValues, imagen: Blob, banner: Blob) => {
        try {
            let id: string
            await agent.CATCursos.create(createCATCursos.id, createCATCursos.codigoCurso, createCATCursos.nombre, createCATCursos.objetivos, createCATCursos.modalidad, createCATCursos.contacto,createCATCursos.iFrame, imagen, banner, createCATCursos.competencias, createCATCursos.perfil, createCATCursos.metodologia, createCATCursos.contenido, createCATCursos.nivel, createCATCursos.certificacion, createCATCursos.phone).then(response => {
             
               id = response.data.id
               this.codigoCursoRespuesta = id
               return response.data.id
            });
            this.setLoadingInitial(false);
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    updateCATCourses = async (_id: any, createCATCursos: createCATCursosFormValues, imagen: Blob, banner: Blob) => {
        try {
            await agent.CATCursos.update(_id, createCATCursos.codigoCurso, createCATCursos.nombre, createCATCursos.objetivos, createCATCursos.modalidad, createCATCursos.contacto,createCATCursos.iFrame, imagen, banner, createCATCursos.competencias, createCATCursos.perfil, createCATCursos.metodologia, createCATCursos.contenido, createCATCursos.nivel, createCATCursos.certificacion, createCATCursos.phone)
            this.setLoadingInitial(false);
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    createCATEdiciones = async (createEdiciones: CATEdicionesFormValues) => {
        try {
            await agent.getCATEdiciones.create(createEdiciones)
            runInAction(() => {
                this.selectedCATEdiciones = createEdiciones;
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    loadCATCursos = async () => {
        this.loadingInitial = true;
        try {
            this.getCATCursosRegistryAll.clear()
            const cursos: Pagination<getCATCursos> = await agent.CATCursos.list();          
            cursos.records.forEach(element => {
                this.setCCTipoDeCuentaAll(element);
            })
            this.totalPages = cursos.totalPages;
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    loadCATCursoss = async (pageNumber: number, size:number) => {
        this.loadingInitial = true;
        try {
            this.getCATCursosRegistryAll.clear()
            const cursos: Pagination<getCATCursos> = await agent.CATCursos.listP(pageNumber, size);         
            cursos.records.forEach(element => {
                this.setCCTipoDeCuentaAll(element);
            })
            this.totalPages = cursos.totalPages;
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    getSearchResult = async(keyword: string) => {
        this.loadingInitial = true;
        try {
            const result: lstCourses[] = await agent.CATCursos.getSearch(keyword);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    getCATNotasAlumno = async () => {
        this.loadingInitial = true;
        try {
            this.getCATNotasRegistry.clear()
            const notas: getCATNotas[] = await agent.CATCursos.getNotas();
            notas.forEach(element => {
                this.setCATNotas(element);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    loadCATCursosByDir = async (direccion:string, delegacion:string) => {
        this.loadingInitial = true;
        try {
            this.getCATCursoRegistryDetail.clear()
            this.getCATCursosRegistry.clear()
            const cursos: getCATCursos[] = await agent.CATCursos.getCursosByDir(direccion, delegacion);
            cursos.forEach(element => {
                this.setCCTipoDeCuenta(element);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    loadCATCursosById = async (id:string) => {
        this.loadingInitial = true;
        let infoCurso: any = 0
        try {
            this.getCATCursoRegistryDetail.clear()
            const cursos: getCATCursoDetail[] = await agent.CATCursos.detail(id);
            cursos.forEach(element => {
                infoCurso = element
                this.setCursoDetail(element);
            })
            this.setLoadingInitial(false);
            return infoCurso
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    /**
     * Metoto que se utilizara para filtrar por niveles
     * @author Freddy Castillo
     * @email fcastillo@inap.gob.gt
     * @param nivel 
     */
    loadCATCursosByLevel = async (nivel:string, delegacion:string) => {
        this.loadingInitial = true;
        //let infoCurso: any = 0
        try {
            this.getCATCursosNew.clear()
            const cursos: getCATCursos[] = await agent.CATCursos.getCursosByDir(nivel, delegacion);
            cursos.forEach(element => {
                this.setCCTcursos(element);
            })            
            this.setLoadingInitial(false);
            return cursos
            
        } catch (error) {
            this.setLoadingInitial(false);
        }
    
    }

    createDiplomaAlumno = async (id:number) => {
        this.loadingInitial = true;
        try {
           await agent.CATCursos.createDiploma(id);
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    private setCursoDetail = (data: getCATCursoDetail) => {
        this.getCATCursoRegistryDetail.set(data.id, data);
    }

    private setCCTipoDeCuenta = (data: getCATCursos) => {
        this.getCATCursosRegistry.set(data.id, data);
    }

    private setCCTipoDeCuentaAll = (data: getCATCursos) => {
        this.getCATCursosRegistryAll.set(data.id, data);
    }
    private setCCTcursos = (data: getCATCursos) => {
        this.getCATCursosNew.set(data.id, data);
    }

    private setCATNotas = (data: getCATNotas) => {
        this.getCATNotasRegistry.set(data.id, data);
    }

    get getCATCursoByCodigo() {
        return Array.from(this.getCATCursoRegistryDetail.values());
    }

    get getCATCursosByCodigo() {
        return Array.from(this.getCATCursosRegistry.values());
    }

    get getCATCursosByLevel() {
        return Array.from(this.getCATCursosNew.values());
    }

    get getCATNotasByCodigo() {
        return Array.from(this.getCATNotasRegistry.values());
    }

    get getCATCursosByCodigoAll() {
        return Array.from(this.getCATCursosRegistryAll.values());
    }

    updateCATEdiciones = async (edicion: CATEdiciones, id:any) => {
        try {
            await agent.getCATEdiciones.update(edicion, id);
            runInAction(() => 
                this.loading = false
            )
        } catch (error) {
        }
    }

    // deleteCATCursos = async (idCliente: string) => {
    //     this.loading = true;
    //     try {
    //         await agent.CATCursos.delete(idCliente);
    //         runInAction(() => {
    //             this.CATCursosRegistry.delete(idCliente);
    //             this.loading = false;
    //         })
    //     } catch (error) {
    //         runInAction(() => {
    //             this.loading = false;
    //         })
    //     }
    // }
}